module.exports = __webpack_public_path__ + "img/info_for_mission.7925da36.svg";